import React, {
  Component,
  Children,
  isValidElement,
  cloneElement
} from "react";
import PropTypes from "prop-types";
import { gatherClasses } from "../../lib/utils";
import {
  DISPLAY_NAME_MAIN,
  DISPLAY_NAME_HEADER,
  DISPLAY_NAME_BODY,
  DISPLAY_NAME_ALERT
} from "./constants";
import { PageContext } from "./pageContext";

class PageMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: true
    };
  }

  hideAlert = () => {
    this.setState({ showAlert: false });
  };

  resolveComponents() {
    let header = null;
    let divider = false;
    let body = null;
    let alert = null;
    const { showAlert } = this.state;
    const { tabPresent } = this.context;
    const { children, divider: propDivider } = this.props;

    Children.forEach(children, child => {
      if (isValidElement(child)) {
        if (child.type.displayName === DISPLAY_NAME_ALERT) {
          alert = cloneElement(child, {
            className: gatherClasses(
              null,
              child.props.className,
              "oui-mb-0 oui-rounded-0"
            ),
            onClose: child.props.onClose || this.hideAlert
          });
        } else if (child.type.displayName === DISPLAY_NAME_HEADER) {
          header = child;
        } else if (child.type.displayName === DISPLAY_NAME_BODY) {
          body = child;
        }
      }
    });

    if (header === null && body !== null) {
      body = cloneElement(body, { header: false });
    }

    if (header !== null && !tabPresent) {
      divider = propDivider;
    }

    if (body !== null) {
      body = cloneElement(body, { alert: alert !== null && showAlert });
    }

    return { alert, header, divider, body };
  }

  render() {
    const { showAlert } = this.state;
    const { alert, header, divider, body } = this.resolveComponents();
    const { dataTestId, dividerFull } = this.props;

    return (
      <div
        data-testid={dataTestId}
        className={gatherClasses(this.props, "oui-page-main")}
      >
        {showAlert ? alert : null}
        {header}
        {divider && (
          <div
            className={gatherClasses(
              null,
              "oui-page-divider",
              dividerFull && "oui-ml-0 oui-mr-0"
            )}
          />
        )}
        {body}
      </div>
    );
  }
}

PageMain.contextType = PageContext;

PageMain.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  divider: PropTypes.bool,
  dataTestId: PropTypes.string,
  dividerFull: PropTypes.bool
};

PageMain.defaultProps = {
  divider: true,
  dataTestId: "orion-page-main"
};

PageMain.displayName = DISPLAY_NAME_MAIN;

export default PageMain;
